import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Security } from "./utils/security";

import "./index.css";
import theme from "./theme.json";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
//import utc from 'dayjs/plugin/utc'; TODO - is utc really needed?

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ActionDialogContainer } from "./components/ActionDialog";

dayjs.extend(quarterOfYear);
dayjs.extend(isoWeek);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ThemeProvider theme={createTheme(theme)}>
        <Security>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <ActionDialogContainer>
                    <App />
                </ActionDialogContainer>
            </LocalizationProvider>
        </Security>
    </ThemeProvider>
);
